export const getFirstName = (name: string) =>
	name.trim().split(" ").filter(Boolean)[0] ?? "";
